<template>
  <v-card>
    <div class="d-flex">
      <v-tabs
        active-class="primary--text"
        hide-slider
        background-color="transparent"
      >
        <v-tab
          class="text-capitalize"
          @click="clearFormErrors(), activeTab = 'update'"
        >
          Change Location
        </v-tab>
        <v-tab
          class="text-capitalize"
          @click="clearFormErrors(), activeTab = 'remove'"
        >
          Remove Location
        </v-tab>
      </v-tabs>

      <v-spacer />

      <v-icon
        class="mx-5"
        small
        @click="$emit('close')"
      >
        mdi-close
      </v-icon>
    </div>

    <v-divider />

    <v-row no-gutters>
      <v-col
        cols="12"
        sm="6"
      >
        <v-card-text class="black--text pa-5">
          <validation-observer ref="changeRequestForm">
            <template v-if="activeTab === 'update'">
              <h3 class="text-h6 primary--text">
                Change Request
              </h3>

              <v-list-item
                two-line
                class="px-0 mb-4"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>Current Address</v-list-item-subtitle>
                  <v-list-item-title>{{ store.formatted_address }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <validation-provider
                v-slot="{ errors }"
                name="Address"
                rules="required"
              >
                <v-textarea
                  v-model="formValues.address"
                  :rows="2"
                  dense
                  outlined
                  label="New Address"
                  class="mb-2"
                  :error="!!errors.length"
                  :error-messages="errors"
                />
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="Latitude"
                rules="required"
              >
                <v-text-field
                  v-model="formValues.latitude"
                  outlined
                  dense
                  type="number"
                  label="Latitude"
                  class="mb-2"
                  :error="!!errors.length"
                  :error-messages="errors"
                />
              </validation-provider>

              <validation-provider
                v-slot="{ errors }"
                name="Longitude"
                rules="required"
              >
                <v-text-field
                  v-model="formValues.longitude"
                  outlined
                  dense
                  type="number"
                  label="Longitude"
                  :error="!!errors.length"
                  :error-messages="errors"
                />
              </validation-provider>

              <div class="d-flex mt-5">
                <v-btn
                  :loading="isLoading"
                  depressed
                  color="primary"
                  @click="validateAndSave"
                >
                  Submit Change Request
                </v-btn>
              </div>
            </template>

            <template v-if="activeTab === 'remove'">
              <h3 class="text-h6 primary--text mb-5">
                Remove Request
              </h3>

              <validation-provider
                v-slot="{ errors }"
                name="Reason"
                rules="required"
              >
                <v-textarea
                  v-model="formValues.reasonToRemove"
                  :rows="5"
                  dense
                  outlined
                  label="Reason to remove address"
                  :error="!!errors.length"
                  :error-messages="errors"
                />
              </validation-provider>

              <div class="d-flex mt-5">
                <v-btn
                  :loading="isLoading"
                  depressed
                  color="primary"
                  @click="validateAndSave"
                >
                  Submit Remove Request
                </v-btn>
              </div>
            </template>
          </validation-observer>
        </v-card-text>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        class="d-none d-sm-block"
      >
        <bing-map
          id="location"
          show-push-pin
          class="lime lighten-5"
          :center="store.lat && store.lng ? {...store} : undefined"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import BingMap from '@/components/commons/BingMap.vue';

function getDefaultFormValues(store) {
  return {
    address: '',
    reasonToRemove: '',
    latitude: store.lat,
    longitude: store.lng,
  };
}

export default {
  components: { BingMap },
  props: {
    store: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeTab: 'update',
      formValues: getDefaultFormValues(this.store),
    };
  },
  methods: {
    clearFormErrors(activeTab) {
      this.activeTab = activeTab;
      this.formValues = getDefaultFormValues(this.store);
      this.$refs.changeRequestForm.reset();
    },
    async validateAndSave() {
      const isFormValid = await this.$refs.changeRequestForm.validate();

      if (!isFormValid) {
        return;
      }

      if (this.activeTab === 'update') {
        this.$emit('update', this.formValues);
        return;
      }

      if (this.activeTab === 'remove') {
        this.$emit('remove', this.formValues);
      }
    },
  },
};
</script>
